var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudioWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.99951C8 2.79037 9.79086 0.999512 12 0.999512C14.2091 0.999512 16 2.79037 16 4.99951V11.9995C16 14.2087 14.2091 15.9995 12 15.9995C9.79086 15.9995 8 14.2087 8 11.9995V4.99951ZM12.75 18.9598C16.2633 18.5856 19 15.6121 19 11.9995C19 11.5853 18.6642 11.2495 18.25 11.2495C17.8358 11.2495 17.5 11.5853 17.5 11.9995C17.5 15.0371 15.0376 17.4995 12 17.4995C8.96243 17.4995 6.5 15.0371 6.5 11.9995C6.5 11.5853 6.16421 11.2495 5.75 11.2495C5.33579 11.2495 5 11.5853 5 11.9995C5 15.6121 7.73668 18.5856 11.25 18.9598V21.4995H9.00001C8.58579 21.4995 8.25 21.8353 8.25 22.2495C8.25 22.6637 8.58579 22.9995 9.00001 22.9995L9.00392 22.9995H11.25H12.75H15C15.4142 22.9995 15.75 22.6637 15.75 22.2495C15.75 21.8353 15.4142 21.4995 15 21.4995H12.75V18.9598Z",
    fill: "white",
    fillOpacity: 0.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2574 20.7646C16.695 21.7646 17.4176 23 18.5648 23L29.4353 23C30.5825 23 31.3051 21.7646 30.7426 20.7646L25.3074 11.102C24.7339 10.0825 23.2661 10.0825 22.6927 11.102L17.2574 20.7646ZM23.3501 17.6L23.3501 14.65C23.3501 14.2911 23.6411 14 24.0001 14C24.359 14 24.6501 14.2911 24.6501 14.65V17.6C24.6501 17.959 24.359 18.25 24.0001 18.25C23.6411 18.25 23.3501 17.959 23.3501 17.6ZM23.25 20.25C23.25 19.8358 23.5858 19.5 24 19.5C24.4142 19.5 24.75 19.8358 24.75 20.25C24.75 20.6642 24.4142 21 24 21C23.5858 21 23.25 20.6642 23.25 20.25Z",
    fill: "#FAAC2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioWarning);
export default __webpack_public_path__ + "static/media/icon-audio-warning.f70134d1cf145c4e60d93a5639069a84.svg";
export { ForwardRef as ReactComponent };